// Статус приёма деклараций с сервера. Используется баннером и экранами подачи,
// чтобы блокировать кнопки, пока IRS недоступен.
import { useEffect, useState } from 'react';

export function useIrsStatus() {
  const [status, setStatus] = useState({ paused: false, message: '', loaded: false });

  useEffect(() => {
    let cancelled = false;
    fetch('/api/system/status/')
      .then((r) => (r.ok ? r.json() : null))
      .then((data) => {
        if (cancelled || !data) return;
        setStatus({
          paused: !!data.filing_paused,
          message: data.message || '',
          loaded: true,
        });
      })
      .catch(() => {
        // Статус недоступен — не блокируем интерфейс.
        if (!cancelled) setStatus((s) => ({ ...s, loaded: true }));
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return status;
}
